import React from 'react';
import { motion } from 'framer-motion';
export function NeuralBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-13">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050510] via-[#0A0A2E] to-[#050510]" data-id="element-14" />

      {/* Neural network lines */}
      <svg className="absolute inset-0 w-full h-full opacity-20" data-id="element-15">
        <defs data-id="element-16">
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-17">
            <stop offset="0%" stopColor="#00D4FF" stopOpacity="0.5" data-id="element-18" />
            <stop offset="100%" stopColor="#00FF88" stopOpacity="0.2" data-id="element-19" />
          </linearGradient>
        </defs>
        {[...Array(20)].map((_, i) => <motion.line key={i} x1={`${Math.random() * 100}%`} y1={`${Math.random() * 100}%`} x2={`${Math.random() * 100}%`} y2={`${Math.random() * 100}%`} stroke="url(#lineGradient)" strokeWidth="1" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: [0, 1, 0],
        opacity: [0, 0.5, 0]
      }} transition={{
        duration: 3 + Math.random() * 2,
        repeat: Infinity,
        delay: Math.random() * 2,
        ease: 'easeInOut'
      }} data-id="element-20" />)}
        {[...Array(30)].map((_, i) => <motion.circle key={`node-${i}`} cx={`${Math.random() * 100}%`} cy={`${Math.random() * 100}%`} r="2" fill="#00D4FF" initial={{
        opacity: 0.2
      }} animate={{
        opacity: [0.2, 0.8, 0.2],
        scale: [1, 1.5, 1]
      }} transition={{
        duration: 2 + Math.random() * 2,
        repeat: Infinity,
        delay: Math.random() * 2,
        ease: 'easeInOut'
      }} data-id="element-21" />)}
      </svg>

      {/* Circuit pattern overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 2px, #00FF88 2px, #00FF88 3px),
                         repeating-linear-gradient(90deg, transparent, transparent 2px, #00FF88 2px, #00FF88 3px)`,
      backgroundSize: '50px 50px'
    }} data-id="element-22" />
    </div>;
}